<template>
    <div class="trace_pain" :style="{'height':painNumber === 0|| painNumber ===5 ? '25rem':'30rem'}">
        <!-- <div class="banshi" v-if="painNumber===0">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div v-for="(item) in painPoints" :key="item.order" class="swiper-slide"
                    :style="{'background-color': slideIndex===item.order ? '#54defc':''}"
                    >
                        <div
                            style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
                            <div><img src="../../assets/行业痛点.png"></div>
                            <div class="slid_title">{{ item.title }}</div>
                            <div class="slide_content">{{ item.content }}</div>
                        </div>
                    </div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div>
        <div class="pain_city" v-else-if="painNumber===1">
            <div class="city_container">
                <div class="city_image">
                    <img src="../../assets/city_pain.jpg">
                </div>
                <div class="city_list">
                    <div v-for="(item, index) in cityPainPoints" :key="index" class="list_container">
                        <div class="list_num">
                            <div class="num_circle" :style="{'backgroundColor':item.color}">
                                {{ index+1 }}
                            </div>
                        </div>
                        <div class="list_text" :style="{'border-left': '0.5rem solid '+item.color}">
                            <div class="text_title">{{ item.title }}</div>
                            <div class="text_content">{{ item.content }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pain_ocean" v-else-if="painNumber===2">
            <div v-for="(item, index) in oceanPainPoints" :key="index" class="ocean_container">
                <div class="ocean_main">
                    <div class="ocean_i"><i class="el-icon-guide" style="font-size: 8rem;"></i></div>
                    <div class="ocean_text">
                        <div class="ocean_title">{{ item.title }}</div>
                        <div class="ocean_content">{{ item.content }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pain_dock" v-else-if="painNumber===3">
            <div v-for="(item, index) in dockPainPoints" 
                 :key="index" class="dock_container"
                 :style="{'background' : painIndex===index ? '#2c5e68':''}"
                 @mouseenter="handleDockPain(index)"
                 @mouseleave="handleUnDockPain(index)"
            >
                <div class="dock_main">
                    <div class="dock_i"><i class="el-icon-guide" style="font-size: 7rem;"></i></div>
                    <div class="dock_text">
                        <div class="dock_title">{{ item.title }}</div>
                        <div class="dock_content">{{ item.content }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pain_factory" v-else-if="painNumber===4">
            <div class="factory_container">
                <div class="factory_list">
                    <div v-for="(item, index) in factoryPainPoints" :key="index" class="list_container">
                        <div v-if="(index+1)%2!==1" style="display: flex; height: 100%; width: 100%;">
                            <div class="list_num">
                                <div class="num_circle" :style="{'background-color' : item.color}">
                                    {{ index+1 }}
                                </div>
                            </div>
                            <div class="list_text" :style="{'border-left':'0.5rem solid'+ item.color}">
                                <div class="text_title">{{ item.title }}</div>
                                <div class="text_content">{{ item.content }}</div>
                            </div>
                        </div>
                        <div v-else style="display: flex; height: 100%;  width: 100%;">
                            <div class="list_text" :style="{'border-right':'0.5rem solid'+ item.color}">
                                <div class="text_title">{{ item.title }}</div>
                                <div class="text_content">{{ item.content }}</div>
                            </div>
                            <div class="list_num">
                                <div class="num_circle" :style="{'background-color' : item.color}">
                                    {{ index+1 }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="banshi" v-if="painNumber===5">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div v-for="(item, index) in energyPainPoints" :key="index" class="swiper-slide"
                    >
                        <div style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
                            <div><img src="../../assets/行业痛点.png"></div>
                            <div class="slid_title">{{ item.title }}</div>
                            <div class="slide_content">{{ item.content }}</div>
                        </div>
                    </div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div> -->
    </div>
</template>

<script>
import Swiper from 'swiper'
import "swiper/css/swiper.min.css"

import { painPoints, cityPainPoints,oceanPainPoints,dockPainPoints, factoryPainPoints,energyPainPoints } from "../../util/constant"
export default {
    data() {
        return{
            painPoints : painPoints,
            cityPainPoints : cityPainPoints,
            oceanPainPoints : oceanPainPoints,
            dockPainPoints : dockPainPoints,
            factoryPainPoints : factoryPainPoints,
            energyPainPoints : energyPainPoints,
            painIndex : -1,
            slideIndex : 2,
            currentIndex: -1,
            headIndex:-1
        }
    },
    props: {
        painNumber: Number
    },
    computed:{
        slideActiveIndex(){
            return this.slideIndex
        }
    },
    methods: {
        handleDockPain(index) {
            this.painIndex = index
        },
        handleUnDockPain() {
            this.painIndex = -1
        },
        getSwiper() {
            const that = this
            this.swiper = new Swiper(".swiper-container", {
                loop: false, // 无缝
                autoplay: { //自动开始
                    delay: 3000, //时间间隔
                    disableOnInteraction: false, //*手动操作轮播图后不会暂停*
                },
                paginationClickable: true,
                slidesPerView: 3, // 一组三个
                spaceBetween: 30, // 间隔
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                // 如果需要分页器
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true, // 分页器可以点击
                },
                on: {
                    slideChange: function()  {
                        console.log(this.activeIndex)
                        if(this.activeIndex == 0) {
                            that.slideIndex = 2
                        }else if(this.activeIndex ===1) {
                            that.slideIndex = 3
                        }else{
                            that.slideIndex = 4
                        }
                    },
                },
            })
        }

    },
    mounted() {
        // console.log(this.title)
        this.getSwiper()

    }
}
</script>

<style scoped lang="less">
.trace_pain {
    background-color: rgb(0, 0, 0);
    width: 100%;
}

.banshi {
        // width: 100%;
        height: 100%;
        margin: 0 auto;
        .swiper-button-prev, .swiper-button-next {
            color: #fff;
        }
        .swiper-slide {
            position: relative;
            height: 282px;
            width: 264px;
            display: flex;
            // padding: 36px 22px;
            background-repeat: no-repeat;
            background-size: contain;
            background-color: #000000;
            border-radius: 16px 0 16px 0px;
            .el-button {
                z-index: 2;
            }
            .slid_title {
                margin: 0.5rem 0 1rem 0;
            }

            .slide_content {
                font-family: "Microsoft Yahei";
                font-size: 1rem;
                width: 90%;
            }
        }
        .swiper-slide.active {
            background: #7c3d3d;
        }
    }
.pain_city {
    height: 100%;
    margin-top: 2rem;
    display: flex;
    align-items: center;
    .city_container {
        display: flex;
        align-items: center;
        height: 100%;
        .city_image {
            display: flex;
            align-items: center;
            height: 100%;
            width: 50%;
            img {
                width: 85%;
                height: 65%;
                border-radius: 2rem;
            }
        }
        .city_list {
            height: 100%;
            width: 50%;
            .list_container {
                display: flex;
                align-items: center;
                height: 33.3%;
                .list_num {
                    width: 10%;
                    height: 30%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .num_circle {
                        width: 50px;
                        height: 50px;
                        border-radius: 90px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
                .list_text{
                    width: 80%;
                    height: 75%;
                    box-shadow: 0 0 1rem rgba(255, 255, 255, 0.871);
                    margin-left: 4%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .text_title {
                        font-size: 1rem;
                        width: 90%;
                        line-height: 2;
                    }
                    .text_content {
                        width: 90%;
                        color:#adadad;
                        line-height: 1.8;
                        font-size: 0.9rem;
                    }
                }
            }
        }
    }
}

.pain_ocean {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    flex-wrap: wrap;
    .ocean_container{
        border : 1px solid rgb(0, 175, 137);
        width: 48%;
        height: 44%;
        margin-right: 1%;
        display: flex;
        align-items: center;
        .ocean_main {
            display: flex;
            width: 100%;
            height: 60%;
            .ocean_i{
                width: 20%;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            .ocean_text{
                width: 70%;
                .ocean_title{
                    font-size: 1.1rem;
                    color: #ededed;
                    line-height: 1rem;
                    padding-bottom: 20px;
                }
                .ocean_content{
                    font-size: 0.9rem;
                    color: #999999;
                }
            }
        }
    }
}

.pain_dock {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    flex-wrap: wrap;
    .dock_container{
        width: 30%;
        height: 44%;
        margin-right: 1%;
        display: flex;
        align-items: center;
        border-radius: 10px;
        background-color: #2b2b2b;
        .dock_main {
            display: flex;
            width: 100%;
            height: 100%;
            flex-direction: column;
            .dock_i{
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
            }
            .dock_text{
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                text-align: center;
                .dock_title{
                    font-size: 1rem;
                }
                .dock_content{
                    font-size: 0.9rem;
                    width: 90%;
                    line-height: 1.5;
                    margin-top: 12px;
                }
            }
        }
    }
}

.pain_factory {
    height: 100%;
    margin-top: 2rem;
    display: flex;
    align-items: center;
    .factory_container {
        display: flex;
        align-items: center;
        height: 100%;
        width: 100%;
        .factory_list {
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            .list_container {
                display: flex;
                align-items: center;
                height: 33.3%;
                width: 50%;
                justify-content: space-around;
                .list_num {
                    width: 10%;
                    height: 80%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin: 0 4%;
                    .num_circle {
                        width: 50px;
                        height: 50px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-radius: 90px;
                    }
                }
                .list_text{
                    width: 80%;
                    height: 90%;
                    box-shadow: 0 0 1rem rgba(252, 252, 252, 0.871);
                    .text_title {
                        text-align: right;
                        width: 95%;
                        height: 30%;
                        line-height: 4;
                        font-size: 1rem;
                    }
                    .text_content {
                        width: 95%;
                        text-align: right;
                        line-height: 1.5;
                        color: #cecece;
                        margin-top: 1rem;
                        font-size: 0.9rem;
                    }
                }
            }
        }
    }
}
.swiper-slide-highlight{
    background-color: green;
}

</style>
